Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingInfo207476195",
  {"verticalLayout":"OfferingInfo207476195--verticalLayout","horizontalLayout":"OfferingInfo207476195--horizontalLayout","column":"OfferingInfo207476195--column","root":"OfferingInfo207476195--root","textButtonWrapper":"OfferingMoreInfoLabel1926614395--textButtonWrapper","divider":"OfferingInfo207476195--divider","buttonWrapper":"OfferingCTA777952320--buttonWrapper","MobileMinHeight":"26px"},
  "",
  9,
  "OfferingInfo207476195"
);

